import React from 'react';
import { MessageBarType } from '@fluentui/react';
import FileTypeIcon from './FileTypeIcon';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { ActionContext } from '../../context/ActionContext';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import ListItemText from '@mui/material/ListItemText';
import { CmicContext } from '../../context/CmicContext';
import { baseFontFamilyStyle } from '../../shared/styles';

const AttachmentContainerUI = props => {
	const { attachment } = props;
	const { setAttachmentData, attachmentData, setSelectedAttachmentsIds, selectedAttachmentsIds } =
		React.useContext(ActionContext);
	const { currentOfficeTheme, setShowToast } = React.useContext(CmicContext);

	const handleAttachmentSelection = () => {};

	const handleRemovedAttachedData = (emailId, attachmentId) => {
		const ids = { ...selectedAttachmentsIds };
		delete ids[attachmentId];
		setSelectedAttachmentsIds(ids);
		setAttachmentData(attachmentData.filter(item => item.id !== attachmentId));
		setShowToast({
			isVisible: true,
			msg: `Attachment removed.`,
			type: MessageBarType.success,
		});
	};

	const truncateString = (str, strOriginal, len) => {
		if (str === strOriginal) return str.length > len ? str.substring(0, len) + '...' : str;
		else return str.length > len ? `* ${str.substring(0, len)}` + '...' : `* ${str}`;
	};

	return (
		<>
			<div style={{ display: 'flex', flexDirection: 'row', flex: '0 0 50%', padding: '5px 0px' }}>
				<span style={{ paddingTop: '2px', marginRight: '7px' }}>
					<RemoveCircleIcon
						fontSize="small"
						color="primary"
						style={{ cursor: 'pointer' }}
						onClick={() => handleRemovedAttachedData(attachment.messageId, attachment.id)}
					/>
				</span>
				<span style={{ marginRight: '6px' }}>
					<FileTypeIcon name={attachment.name} iconStyles={{ margin: '0 0.5rem' }} />
				</span>
				<div onClick={() => handleAttachmentSelection(attachment.messageId, attachment.id)} key={attachment.id}>
					<Box sx={{ width: 'auto', height: 'auto' }}>
						<Grid container justifyContent="center">
							<Grid item>
								<Tooltip
									title={
										attachment.name === attachment.originalName ? (
											attachment.name
										) : (
											<div>
												{attachment.name}
												<br />({`Original Name: ${attachment.originalName}`})
											</div>
										)
									}
									componentsProps={{
										tooltip: {
											sx: {
												color: currentOfficeTheme.bodyForegroundColor,
												backgroundColor: currentOfficeTheme.bodyBackgroundColor,
												fontSize: '13px',
												border: '0.5px solid grey',
												padding: '5px',
											},
										},
									}}
								>
									<Button
										style={{
											fontFamily: baseFontFamilyStyle,
											fontSize: '11px',
											color: 'black',
											paddingTop: '2px',
											paddingLeft: '1px',
											textTransform: 'none',
											whiteSpace: 'nowrap',
											overflow: 'hidden',
											textOverflow: 'ellipsis',
										}}
									>
										<ListItemText
											sx={{
												margin: '0px',
												'& .MuiTypography-root': {
													padding: '0px',
													fontFamily: baseFontFamilyStyle,
													color: currentOfficeTheme.controlForegroundColor,
													width: 'auto',
													fontSize: '13px',
												},
											}}
											id={attachment.id}
											primary={`${truncateString(attachment.name, attachment.originalName, 28)} `}
										/>
									</Button>
								</Tooltip>
							</Grid>
						</Grid>
					</Box>
				</div>
			</div>
		</>
	);
};

export default AttachmentContainerUI;
